// src/pages/UserHome.js
import React, { useState, useEffect } from 'react';

const UserHome = () => {
  const [personalData, setPersonalData] = useState({
    reminders: [],
    recentActivity: [],
  });

  // Simulating fetching personalized data for the logged-in user
  useEffect(() => {
    const fetchUserData = () => {
      const userReminders = [
        { id: 1, content: 'Submit Will Document' },
        { id: 2, content: 'Pay family reunion fees' },
      ];
      const userActivity = [
        { id: 1, content: 'Uploaded family photos' },
        { id: 2, content: 'Posted a reminder about Jimmy’s birthday' },
      ];
      setPersonalData({ reminders: userReminders, recentActivity: userActivity });
    };

    fetchUserData();
  }, []);

  return (
    <div className="user-home">
      <h1>Welcome to Your Personal Dashboard</h1>

      <div className="reminders">
        <h2>Reminders</h2>
        {personalData.reminders.length === 0 ? (
          <p>No reminders at the moment.</p>
        ) : (
          <ul>
            {personalData.reminders.map((reminder) => (
              <li key={reminder.id}>{reminder.content}</li>
            ))}
          </ul>
        )}
      </div>

      <div className="recent-activity">
        <h2>Your Recent Activity</h2>
        {personalData.recentActivity.length === 0 ? (
          <p>No recent activity.</p>
        ) : (
          <ul>
            {personalData.recentActivity.map((activity) => (
              <li key={activity.id}>{activity.content}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default UserHome;